import { GenericApi } from "./generic.api";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ICategory } from "../model/ddb.model";
import { Observable } from "rxjs";
import { createUrl, getPublicRoutesHeaders, queryToParams } from "./api.util";
import { IQueryFilter, QueryResult } from "../model/query.filter.class";

// Convenience Type
type T = ICategory;

@Injectable()
export class CategoryApi extends GenericApi<T> {
	public path = "category";

	constructor(public httpClient: HttpClient) {
		super(httpClient);
	}

	readonly restore = (id: number | string): Observable<{ success: boolean }> =>
		this.httpClient.get<{ success: boolean }>(
			createUrl(this.path, id, "restore"),
			{}
		);

	readonly unAuthlist = (query: IQueryFilter): Observable<QueryResult<ICategory>> => {
		return this.httpClient.get<QueryResult<ICategory>>(
			createUrl(this.path, "unauth"),
			{
				params: queryToParams(query),
				headers: getPublicRoutesHeaders(),
			}
		);
	};

}
